var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList } from '../../../../Fct/generics/FctParams';
import { FaLock } from 'react-icons/fa';
import { compoundTokens, getCompoundPluginAddressesInput } from '../constants';
export var EnterMarkets = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'ACTION',
    method: 'enterMarkets',
    description: 'Borrow ETH or ERC20 tokens',
    supportedContracts: [
        { chainId: 1, address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B' },
    ],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: __assign(__assign({ to: new FctAddress({ destination: 'comptroller' }) }, ((function () {
                var inputs = getCompoundPluginAddressesInput({ chainId: chainId }).tokens;
                // Add preview and icon to each address input
                Object.keys(inputs).forEach(function (key) {
                    inputs[key].isPreview = true;
                    inputs[key].icon = FaLock;
                });
                return inputs;
            })())), { methodParams: {
                    cTokens: new FctAddressList({ readonly: true, isPreview: true, icon: FaLock }),
                } }),
            output: {},
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId;
        var chainTokens = compoundTokens.filter(function (token) { return token.chainId === Number(chainId); });
        var getParamsAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var cTokens, tokensHash;
            return __generator(this, function (_a) {
                cTokens = [];
                tokensHash = new Set();
                chainTokens.forEach(function (_token, index) {
                    var tokenLabel = "address".concat(index + 1);
                    var nexTokenLabel = "address".concat(index + 2);
                    if (!input[tokenLabel])
                        return;
                    if (!input[tokenLabel].value) {
                        if (!input[nexTokenLabel])
                            return;
                        if (!input[nexTokenLabel].value) {
                            input[nexTokenLabel].hidden = true;
                            return;
                        }
                        input[tokenLabel].value = input[nexTokenLabel].value;
                        input[nexTokenLabel].value = undefined;
                        return;
                    }
                    cTokens.push(input[tokenLabel].value);
                    tokensHash.add(input[tokenLabel].value);
                    if (!input[nexTokenLabel])
                        return;
                    input[nexTokenLabel].options = chainTokens.filter(function (token) { return !tokensHash.has(token.value); });
                    input[nexTokenLabel].hidden = false;
                });
                return [2 /*return*/, { params: { methodParams: { cTokens: cTokens } }, error: undefined }];
            });
        }); };
        return { get: getParamsAsync, depParamKeys: getCompoundPluginAddressesInput({ chainId: chainId }).labels };
    },
});
